<script setup lang="ts">
import vPreloadImg from '@/ts/directives/v-preload-img.ts';
import model from '@/ts/model.ts';
import Btn from './btn.vue';

import androidImg from '@/assets/android.svg';
import iosImg from '@/assets/ios.svg';

const appstoreImg = import.meta.glob('@/assets/third-party-stores/appstore-btn-*.*', { eager: true, query: '?url', import: 'default' });
const playstoreImg = import.meta.glob('@/assets/third-party-stores/googleplay-btn-*.*', { eager: true, query: '?url', import: 'default' });

defineProps<{loc: 'header' | 'footer'}>();
</script>

<template>
    <div class="links">
        <a :href="model.clientConfig.appConfig?.playstoreLink" target="_blank">
            <template v-if="model.siteKey == 'fund'">
                <img v-preload-img="playstoreImg" :data-location="loc" v-mobile>
            </template>
            <template v-else>
                <btn :skin="'info'" :loc="'web-header'">
                    <div class="link-text">
                        <img :src="androidImg" :data-location="loc" v-mobile>
                        <span>Android</span>
                    </div>
                </btn>
            </template>
        </a>
        <a :href="model.clientConfig.appConfig?.appstoreLink" target="_blank">
            <template v-if="model.siteKey == 'fund'">
                <img v-preload-img="appstoreImg" :data-location="loc" v-mobile>
            </template>
            <template v-else>
                <btn :skin="'info'" :loc="'web-header'">
                    <div class="link-text">
                        <img :src="iosImg" :data-location="loc" class="ios" v-mobile>
                        <span>iOS</span>
                    </div>
                </btn>
            </template>
        </a>
    </div>
</template>

<style lang="scss" scoped>
    @use '@/scss/shared';
    .links{
        display: flex;
        & > a{
            &:link,
            &:visited,
            &:active{
                display: flex;
                justify-content: center;
                align-items: center;
                transition: transform .25s;
                text-decoration: none;
            }
            &:hover{
                transform: scale(1.1);
            }
            & .link-text{
                display: flex;
                justify-content: center;
                align-items: center;
                & > img{
                    &[data-location="header"]{
                        padding-right: 5px;
                        height: 15px;
                        &[data-mobile]{
                            height: 13px;
                        }
                        &.ios{
                            transform:translateY(-1px);
                        }
                    }
                    &[data-location="footer"]{
                        padding-right: 5px;
                        height: 20px;
                        &[data-mobile]{
                            height: 17px;
                        }
                        &.ios{
                            transform:translateY(-2px);
                        }
                    }
                }
            }
            & > img{
                &[data-location="header"]{
                    width: 100px;
                    height: 30px;
                    padding-right: 10px;
                    margin: 0;
                    &[data-mobile]{
                        width: 80px;
                        height: 25px;
                        padding-right: 5px;
                    }
                }
                &[data-location="footer"]{
                    width: 150px;
                    margin: 0 5px;
                    @media (max-width: shared.$mobile-width){
                        width: 100px;
                    }
                }
            }
        }
    }
</style>